import { useCallback, useEffect, useRef, useState } from "react";
import { Ifilter } from "../../../Interfaces/filter";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { TurnoService } from "../../../services/auxiliar/turnoService";


const UseComboTurno = (isOpen: boolean) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataComboTurno, setDataComboTurno] = useState<IComboBoxOption[]>([]);
    const comboBoxRefTurno = useRef<IComboBox>(null);

    const onClickComboTurno = () => comboBoxRefTurno.current?.focus(true);

    const onChangeTurno = (value:any) => {
        setFilter({ ...filter, search: value });
    }

    const _onkeyUpSearchTurno = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefTurno.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        TurnoService.Comboturno(filter, newController).then((res) => {
            if (res.status === 200) {
                setDataComboTurno(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarCombo();
        }
    }, [isOpen]);

    useEffect(() => {
        if (filter.search != "") {
            listarCombo()
        }
    }, [filter.search])

    return {
        dataComboTurno,
        onClickComboTurno,
        _onkeyUpSearchTurno,
        comboBoxRefTurno,
        onChangeTurno,
        filter,
        setFilter
    };
}

export { UseComboTurno }